module.exports = __webpack_public_path__ + "img/117.d9430cdd.jpg";